import axios from 'axios';
import { getAuthTokenUrl } from 'app/services/AuthService/config';
import { removeNotAllowedHeader } from 'shared/api/removeNotAllowedHeader';
import { RefreshAuthTokenApi } from './types';

const refreshApi = axios.create({
  headers: { 'Content-Type': 'multipart/form-data' },
  withCredentials: false,
});

export const refreshAuthTokenApi: RefreshAuthTokenApi = async params => {
  const authUrl = getAuthTokenUrl();
  const formData = new FormData();

  formData.append('grant_type', params.grantTypeCode);
  formData.append('client_id', params.clientId);
  formData.append('refresh_token', params.refreshToken);

  const { data } = await refreshApi.post(authUrl, formData, {
    transformRequest: [
      removeNotAllowedHeader('X-CSRFToken'),
      removeNotAllowedHeader('Authorization'),
    ],
  });

  return data;
};
